// ----------------------------------------------------------------------
export const Container = () => {
    return {
        MuiContainer: {
            styleOverrides: {
                root: {}
            }
        }
    };
};
//# sourceMappingURL=Container.js.map